import React from 'react';
import { StarIcon } from 'lucide-react';
function StarRating() {
  return <div className="flex gap-0.5" data-id="element-573">
      <StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-574" />
      <StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-575" />
      <StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-576" />
      <StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-577" />
      <StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-578" />
    </div>;
}
export function TestimonialsSection() {
  return <section className="bg-background py-16 sm:py-24" data-id="element-579">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-580">
        <div className="text-center mb-12" data-id="element-581">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground" data-id="element-582">
            Lo Que Dicen Nuestras Clientas
          </h2>
          <p className="mt-3 text-muted-foreground text-lg" data-id="element-583">
            Opiniones reales de personas reales.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-584">
          {/* María */}
          <div className="bg-card rounded-xl shadow-sm border border-border p-6 flex flex-col gap-4" data-id="element-585">
            <StarRating data-id="element-586" />
            <blockquote className="text-foreground text-lg leading-relaxed flex-1" data-id="element-587">
              "Lo que más noto es menos ansiedad por la comida por la noche. En
              3 semanas ya noté diferencia en mi vientre."
            </blockquote>
            <div className="flex items-center gap-3 pt-2 border-t border-border" data-id="element-588">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 border-2 border-green-100" data-id="element-589">
                <img src="https://cdn.magicpatterns.com/uploads/q9JnEZUR2GRxvJnVLKd9RQ/imgi_32_1765696241-imgi_23_1760554617-227_-_Review_photos_(2).png" alt="María" className="w-full h-full object-cover object-top" data-id="element-590" />
              </div>
              <div data-id="element-591">
                <p className="font-semibold text-foreground text-sm" data-id="element-592">
                  María, 41
                </p>
                <p className="text-muted-foreground text-xs" data-id="element-593">Madrid</p>
              </div>
            </div>
          </div>

          {/* Laura */}
          <div className="bg-card rounded-xl shadow-sm border border-border p-6 flex flex-col gap-4" data-id="element-594">
            <StarRating data-id="element-595" />
            <blockquote className="text-foreground text-lg leading-relaxed flex-1" data-id="element-596">
              "No es magia, pero me ayuda a sentirme más en control. Menos
              antojos y más energía durante el día."
            </blockquote>
            <div className="flex items-center gap-3 pt-2 border-t border-border" data-id="element-597">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 border-2 border-green-100" data-id="element-598">
                <img src="https://cdn.magicpatterns.com/uploads/cmXxikKmaUgxVVe7vtShgh/imgi_31_1765695299-imgi_21_1760554614-227_-_Review_photos_(1).png" alt="Laura" className="w-full h-full object-cover object-top" data-id="element-599" />
              </div>
              <div data-id="element-600">
                <p className="font-semibold text-foreground text-sm" data-id="element-601">
                  Laura, 52
                </p>
                <p className="text-muted-foreground text-xs" data-id="element-602">Valencia</p>
              </div>
            </div>
          </div>

          {/* Sofía */}
          <div className="bg-card rounded-xl shadow-sm border border-border p-6 flex flex-col gap-4" data-id="element-603">
            <StarRating data-id="element-604" />
            <blockquote className="text-foreground text-lg leading-relaxed flex-1" data-id="element-605">
              "Mi ropa me queda mejor y tengo más energía. Llevo 2 meses
              tomándolo y no lo dejaría."
            </blockquote>
            <div className="flex items-center gap-3 pt-2 border-t border-border" data-id="element-606">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 border-2 border-green-100" data-id="element-607">
                <img src="https://cdn.magicpatterns.com/uploads/myi2429w61urcg6fBawDaH/imgi_27_1765695300-imgi_19_1760554606-227_-_Review_photos.png" alt="Sofía" className="w-full h-full object-cover object-top" data-id="element-608" />
              </div>
              <div data-id="element-609">
                <p className="font-semibold text-foreground text-sm" data-id="element-610">
                  Sofía, 44
                </p>
                <p className="text-muted-foreground text-xs" data-id="element-611">Sevilla</p>
              </div>
            </div>
          </div>
        </div>

        {/* Before/After row */}
        <div className="mt-16" data-id="element-612">
          <h3 className="text-2xl font-bold text-foreground text-center mb-8" data-id="element-613">
            Transformaciones Reales
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-614">
            <div className="rounded-xl overflow-hidden shadow-sm border border-border" data-id="element-615">
              <img src="https://cdn.magicpatterns.com/uploads/q9JnEZUR2GRxvJnVLKd9RQ/imgi_32_1765696241-imgi_23_1760554617-227_-_Review_photos_(2).png" alt="Transformación María" className="w-full h-64 object-cover" data-id="element-616" />
              <div className="p-3 bg-card text-center" data-id="element-617">
                <p className="text-sm font-medium text-foreground" data-id="element-618">
                  María, 41 — Madrid
                </p>
                <p className="text-xs text-muted-foreground" data-id="element-619">
                  Resultado en 8 semanas
                </p>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-sm border border-border" data-id="element-620">
              <img src="https://cdn.magicpatterns.com/uploads/cmXxikKmaUgxVVe7vtShgh/imgi_31_1765695299-imgi_21_1760554614-227_-_Review_photos_(1).png" alt="Transformación Laura" className="w-full h-64 object-cover" data-id="element-621" />
              <div className="p-3 bg-card text-center" data-id="element-622">
                <p className="text-sm font-medium text-foreground" data-id="element-623">
                  Laura, 52 — Valencia
                </p>
                <p className="text-xs text-muted-foreground" data-id="element-624">
                  Resultado en 10 semanas
                </p>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-sm border border-border" data-id="element-625">
              <img src="https://cdn.magicpatterns.com/uploads/9jVxMEZimf1GE4W686E1Ft/imgi_20_1765695302-imgi_14_1760554883-227_-_Funnel_Image_(11).png" alt="Transformación Sofía" className="w-full h-64 object-cover" data-id="element-626" />
              <div className="p-3 bg-card text-center" data-id="element-627">
                <p className="text-sm font-medium text-foreground" data-id="element-628">
                  Sofía, 44 — Sevilla
                </p>
                <p className="text-xs text-muted-foreground" data-id="element-629">
                  Resultado en 12 semanas
                </p>
              </div>
            </div>
          </div>
          <p className="text-center text-xs text-muted-foreground mt-4" data-id="element-630">
            Resultados individuales pueden variar.
          </p>
        </div>
      </div>
    </section>;
}